module.exports = __webpack_public_path__ + "img/paypal.125fa367.png";